module.exports = __webpack_public_path__ + "media/images/poncebattery-team-1-c7fa5295.jpg";